export const transformTimeframeStatus = status =>
  status === 'Signed'
    ? 'ArchivedSigned'
    : status === 'NotSigned'
    ? 'ArchivedUnsigned'
    : 'Archived';
